import { render } from "./WhatsappChat.vue?vue&type=template&id=9fac7924&scoped=true"
import script from "./WhatsappChat.vue?vue&type=script&lang=js"
export * from "./WhatsappChat.vue?vue&type=script&lang=js"

import "./WhatsappChat.vue?vue&type=style&index=0&id=9fac7924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fac7924"]])

export default __exports__